import React from 'react';
import { useTranslations } from 'next-intl';

import { SunIcon, MoonIcon, CircleIcon } from '@phosphor-icons/react';
import { IconButton } from '@unity/cloud-ui';
import { useColorScheme } from '@unity/cloud-ui/styles';

import { dataLayerPush, EVENT_USER_EVENT } from '@/lib/data-layer-push';

export const ThemeSwitcher = () => {
  const t = useTranslations();
  const { colorScheme, setColorScheme } = useColorScheme();

  const handleClick = () => {
    const newColorScheme = colorScheme === 'dark' ? 'light' : 'dark';

    setColorScheme(newColorScheme);
    dataLayerPush({
      event: EVENT_USER_EVENT,
      event_name: 'ui_action',
      properties: {
        ui_action: 'color_scheme_toggle',
        ui_color_scheme: newColorScheme,
      },
    });
  };

  return (
    <IconButton aria-label={t('header:theme-switcher:aria-label')} onClick={handleClick} size="medium">
      {colorScheme === 'dark' && <SunIcon data-testid="icon-dark-mode" weight="fill" />}
      {colorScheme === 'light' && <MoonIcon data-testid="icon-light-mode" />}
      {!colorScheme && <CircleIcon />}
    </IconButton>
  );
};
